import { render, staticRenderFns } from "./sms_module.vue?vue&type=template&id=07fc08b0&scoped=true"
import script from "./sms_module.vue?vue&type=script&lang=js"
export * from "./sms_module.vue?vue&type=script&lang=js"
import style0 from "./sms_module.vue?vue&type=style&index=0&id=07fc08b0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07fc08b0",
  null
  
)

export default component.exports